<template>
    <ErrorDialog
        :show="show"
        title="Ticket Respond Error"
        @close-error-dialog="close"
    >
        <template v-slot:errorMessage>
            <div class="py-4">
                {{ respondedToText }}
            </div>
            <div v-if="errorResults.length > 0">
                <ul>
                    <li 
                        v-for="(errorMessage, index) of errorMessages"
                        :key="index"
                    >
                        {{ errorMessage }}
                    </li>
                </ul>
            </div>
        </template>
    </ErrorDialog>
</template>
<script>
import ErrorDialog from './ErrorDialog.vue';
export default {
    components: {
        ErrorDialog,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        respondResult: {
            type: Object,
            default: () => ({}),
            required: true,
        }
    },
    computed: {
        results() {
            return Array.isArray(this.respondResult.tickets) ? this.respondResult.tickets : [];
        },
        resultCount() {
            return this.results.length;
        },
        errorResults() {
            return this.results.filter(result => {
                return result?.result?.result  === 'ERR';
            });
        },
        errorMessages() {
            let allErrors = this.errorResults;
            let errorMessages = [];
            for(let error of allErrors) {
                if(!errorMessages.includes(error?.result?.message)) {
                    errorMessages.push(error?.result?.message);
                }
            }
            return errorMessages;
        },
        respondedToText() {
            let succesCount = this.resultCount - this.errorResults.length;
            let failedCount = this.errorResults.length;
            return `${succesCount} of ${this.resultCount} ticket${this.resultCount > 1 ? 's' : ''} were responded to.`
               + `  ${failedCount} ticket${failedCount > 1 ? 's' : ''} failed to be responded to.`;
        }
    },
    methods: {
        close() {
            this.$emit('close-response-error-dialog');
        }
    }
};
</script>